<template>
  <div v-if="data" class="chat-order p-12 bg-white" style="width:340px;">
    <div class="mb-12">
      <span class="fs-18" style="font-weight:bold;">您正在咨询的订单</span>
      <div class="color-primary fs-16" style="float:right;">{{order.count}}件商品</div>
    </div>
    <div class="d-flex">
      <img style="width:78px;height:78px;display:inline-block;" :src="order.picture" />
      <div class="pt-10 pr-15 pb-10 pl-15" style="background: #F9F9F9;width:200px;">
        <div class="fs-16 clamp mb-15">{{order.title}}</div>
        <div class="fs-14 color-lightGray">{{`共计${order.count}件商品，合计￥${order.totalAmount}`}}</div>
      </div>
    </div>
    <div>
      <div class="pt-12 color-lightGray">订单：{{order.orderId}}</div>
      <div class="pt-12 color-lightGray">时间：{{order.createTime}}</div>
    </div>
    <div>
      <el-button style="float:right;" @click="viewDetail" type="primary" size="small" round>查看</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      order: {
        count: '',
        orderId: '',
        createTime: '',
        address: '',
        title: '',
        picture: '',
        totalAmount: ''
      }
    }
  },
  created () {
    if (this.data) {
      this.order.orderId = this.data.orderId
      this.order.count = this.data.count
      this.order.createTime = this.data.createTime
      this.order.address = this.data.address
      this.order.title = this.data.title
      this.order.picture = this.data.picture
      this.order.totalAmount = this.data.totalAmount
    }
  },
  methods: {
    viewDetail () {
       window.open(this.$router.resolve({ path: '/order/item', query: { order_id: this.order.orderId } }).href)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>